import { useEffect } from "react";

/**
 * Adds the 'is-visible' class to all .reveal elements when they enter the viewport.
 * Includes a safety fallback so content is never left permanently hidden if the
 * IntersectionObserver never fires for an element (e.g. tall elements, layout quirks).
 */
export default function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!els.length) return;

    const show = (el) => el.classList.add("is-visible");

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));

    // Safety net: reveal anything still hidden shortly after mount.
    const fallback = setTimeout(() => els.forEach(show), 1400);

    return () => {
      io.disconnect();
      clearTimeout(fallback);
    };
  }, []);
}
